import { Phone, Mail, MapPin, IndianRupee } from "lucide-react";
import { Link } from "react-router-dom";
import { WHATSAPP_DISPLAY, PHONE_SECONDARY, CONTACT_EMAIL, openWhatsApp, openPaymentPage, DEFAULT_WA_MESSAGE } from "@/lib/whatsapp";

const Footer = () => (
  <footer className="bg-navy text-slate-300" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 md:py-20 grid md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3 mb-6">
          <img
            src="/logo.jpeg"
            alt="Sharpin Healthcare Services"
            className="h-14 w-14 rounded-full object-cover ring-2 ring-tealbrand/30 bg-white"
          />
          <div className="leading-tight">
            <span className="font-display font-bold text-xl tracking-tight text-white block">SHARPIN</span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-tealbrand-light font-semibold">Healthcare Services</span>
          </div>
        </div>
        <p className="text-sm leading-relaxed max-w-sm mb-2">
          Hospital-grade homecare across Delhi NCR — verified caretakers, GNM &amp; B.Sc
          nurses, baby caretakers, japa maids and ICU-at-home setups.
        </p>
        <p className="text-xs uppercase tracking-[0.25em] text-tealbrand-light font-bold">
          Care Beyond Treatment
        </p>
      </div>

      <div className="md:col-span-3">
        <h4 className="text-xs uppercase tracking-[0.25em] font-bold text-white mb-6">Explore</h4>
        <ul className="space-y-3 text-sm">
          <li><a href="#services" className="hover:text-tealbrand-light transition-colors" data-testid="footer-link-services">Services</a></li>
          <li><a href="#pricing" className="hover:text-tealbrand-light transition-colors" data-testid="footer-link-pricing">Pricing</a></li>
          <li><a href="#join" className="hover:text-tealbrand-light transition-colors" data-testid="footer-link-join">Request &amp; Join</a></li>
          <li><Link to="/terms" className="hover:text-tealbrand-light transition-colors" data-testid="footer-link-terms">Terms of Service</Link></li>
          <li>
            <button onClick={() => openWhatsApp(DEFAULT_WA_MESSAGE)} className="hover:text-tealbrand-light transition-colors" data-testid="footer-whatsapp-link">
              WhatsApp Us
            </button>
          </li>
          <li>
            <button onClick={openPaymentPage} className="inline-flex items-center gap-1.5 hover:text-tealbrand-light transition-colors" data-testid="footer-pay-link">
              <IndianRupee className="h-3.5 w-3.5" /> Pay Now
            </button>
          </li>
        </ul>
      </div>

      <div className="md:col-span-4">
        <h4 className="text-xs uppercase tracking-[0.25em] font-bold text-white mb-6">Contact</h4>
        <ul className="space-y-4 text-sm">
          <li className="flex items-center gap-3">
            <Phone className="h-4 w-4 text-tealbrand-light shrink-0" />
            <a href={`tel:${WHATSAPP_DISPLAY}`} className="hover:text-tealbrand-light transition-colors" data-testid="footer-phone-primary">{WHATSAPP_DISPLAY}</a>
          </li>
          <li className="flex items-center gap-3">
            <Phone className="h-4 w-4 text-tealbrand-light shrink-0" />
            <a href={`tel:${PHONE_SECONDARY}`} className="hover:text-tealbrand-light transition-colors" data-testid="footer-phone-secondary">{PHONE_SECONDARY}</a>
          </li>
          <li className="flex items-center gap-3">
            <Mail className="h-4 w-4 text-tealbrand-light shrink-0" />
            <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-tealbrand-light transition-colors break-all" data-testid="footer-email">{CONTACT_EMAIL}</a>
          </li>
          <li className="flex items-center gap-3">
            <MapPin className="h-4 w-4 text-tealbrand-light shrink-0" />
            <span data-testid="footer-location">Delhi NCR, India</span>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Sharpin Healthcare Services. All rights reserved.</p>
        <p className="max-w-xl" data-testid="footer-liability-note">
          Sharpin Healthcare Services is not liable for any direct or indirect loss of any
          person arising from homecare services. See Terms of Service.
        </p>
        <Link to="/admin" className="hover:text-tealbrand-light transition-colors" data-testid="footer-admin-link">
          Admin
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
